import React from "react";

import { addressValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationCity(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="townOrCity"
			name="city"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:CITY_LABEL"
			inputClassName="input input--sml input"
			placeholder="registration:CITY_PLACEHOLDER"
			pattern={{
				value: addressValidationPattern,
				message: "registration:CITY_CHARACTER",
			}}
			required
		/>
	);
}
